module.exports = __webpack_public_path__ + "static/media/aurora-ipad.8dc840db.jpg";